import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@shared-components/shadcn/form";
import { Input } from "@shared-components/shadcn/input";
import React from "react";
import { type UseFormReturn } from "react-hook-form";

interface SimpleFormFieldProps {
  name: string;
  label?: string | React.ReactNode;
  required?: boolean;
  placeholder?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: UseFormReturn<any, any>;
  className?: string;
  inputClassName?: string;
  disabled?: boolean;
}

const SimpleFormField = (props: SimpleFormFieldProps) => {
  return (
    <FormField
      control={props.form.control}
      name={props.name}
      render={({ field }) => (
        <FormItem className={props.className}>
          {props.label && (
            <FormLabel required={props.required}>{props.label}</FormLabel>
          )}
          <FormControl>
            <Input
              className={props.inputClassName}
              placeholder={props.placeholder}
              disabled={props.disabled}
              {...field}
              onChange={(value) => {
                props.form.clearErrors(props.name);
                field.onChange(value);
              }}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default SimpleFormField;
